import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import seo from '../seo-routes.json'

const SITE_URL = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, '')

// Aggiorna (o crea) un tag nel <head> senza duplicare quelli statici di public/index.html
function setHeadTag(selector, tagName, attrs) {
  let el = document.head.querySelector(selector)
  if (!el) {
    el = document.createElement(tagName)
    document.head.appendChild(el)
  }
  Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value))
}

function Seo() {
  const { pathname } = useLocation()

  useEffect(() => {
    const page = seo.routes[pathname] || seo.notFound
    const url = `${SITE_URL}${pathname === '/' ? '/' : pathname}`
    const robots = page.indexable ? 'index, follow' : 'noindex, follow'

    document.title = page.title
    setHeadTag('meta[name="description"]', 'meta', { name: 'description', content: page.description })
    setHeadTag('meta[name="robots"]', 'meta', { name: 'robots', content: robots })
    setHeadTag('link[rel="canonical"]', 'link', { rel: 'canonical', href: url })
    setHeadTag('meta[property="og:title"]', 'meta', { property: 'og:title', content: page.title })
    setHeadTag('meta[property="og:description"]', 'meta', { property: 'og:description', content: page.description })
    setHeadTag('meta[property="og:url"]', 'meta', { property: 'og:url', content: url })
    setHeadTag('meta[name="twitter:title"]', 'meta', { name: 'twitter:title', content: page.title })
    setHeadTag('meta[name="twitter:description"]', 'meta', { name: 'twitter:description', content: page.description })
  }, [pathname])

  return null
}

export default Seo
